<template>
  <div class="page-login">
    <div class="form-container">
      <div class="logo">
        <img class="logo-image" src="~assets/img/logo-somfy.svg" alt="Logo Somfy">
      </div>
      <div class="welcome-text" v-html="$t('login.welcome-text')"></div>

      <template v-if="formLogin">
        <h2 class="section-title">{{$t('login.form-title')}}</h2>
        <form v-on:submit="submit">
          <div class="error" v-if="error">
            <p>{{error.message}}</p>
          </div>
          <ui-textbox name="username"
                      :placeholder="$t('login.placeholder.username')"
                      v-model="username"
                      :disabled= "isLoading"
                      :required="true"
                      class="dark">
          </ui-textbox>
          <ui-textbox name="password"
                      :placeholder="$t('login.placeholder.password')"
                      v-model="password"
                      :disabled= "isLoading"
                      :required="true"
                      type="password"
                      class="dark">
          </ui-textbox>
          <ui-button type="normal" button-type="submit" color="primary" raised :loading="isLoading">{{$t('login.button.submit')}}</ui-button>
          <a class="forgot-password-link" target="_blank" :href="$t('login.forgot-password-url')">{{$t('login.label.forgot-password')}}</a>
        </form>
      </template>
      <div class="button-group" v-else>
        <a class="ui-button ui-button--type-normal ui-button--color-primary ui-button--icon-position-left ui-button--size-normal is-raised" :href="B2BUrl + '/o/somfy/sso_login?redirect=ext_orderTracking'">
          <div class="ui-button__content">{{$t('login.button.submit')}}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-login',
  data () {
    return {
      isLoading: false,
      username: '',
      password: '',
      SSOUrl: '',
      B2BUrl: ''
    }
  },
  computed: {
    error: function () {
      return this.$store.state.authError
    },
    formLogin: function () {
      return this.$store.state.formLogin
    }
  },
  mounted () {
    if (this.formLogin) {
      this.SSOUrl = process.env.SSO_URL
    }
    else {
      this.B2BUrl = process.env.B2B_URL
      window.location.href = process.env.B2B_URL + '/o/somfy/sso_login?redirect=ext_orderTracking'
    }
  },
  methods: {
    submit: function (e) {
      e.preventDefault()
      var self = this
      this.isLoading = true
      this.$store.dispatch('authUser', { username: this.username, password: this.password }).then(
        (response) => {
          self.isLoading = false
        }
      )
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .page-login {
    background-color: $somfy;
    height: 100%;

    position: relative;

    .form-container {
      width: 320px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%); /* Safari IOS */
      -ms-transform: translate(-50%, -50%); /* IE 9 */

      .logo {
        text-align: center;

        img {
          width: 162px;
        }
      }

      .welcome-text {
        margin-top: 30px;
        margin-bottom: 30px;
        font-size: 18px;
        color: $body-light;
        text-align: center;
      }

      form {
        .error {
          color: $danger;
          font-size: 14px;

          p {
            margin: 0;
          }
        }

        .ui-textbox {
          margin-bottom: 25px;
        }

        button.ui-button[type=submit] {
          margin-top: 10px;
          width: 100%;
        }

        a.forgot-password-link {
          display: block;
          margin-top: 20px;
          text-align: center;
          font-size: 14px;
        }
      }
    }
    .button-group {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// PageLogin.vue?3372ac7a